module.exports = __webpack_public_path__ + "static/media/Furret_gaussian2.94c367a3.png";